const state = {
  data: [],
  needReload: false,
  param: {
    filter: {},
    sort: [{ field: 'templateNo', order: 'DESC' }]
  },
  totalPages: 0,
  totalCount: 0,
  selectedNoArray: [],
  inputValues: {}
}

const actions = {
  CHANGE_FILTER: ({ commit }, payload) => {
    commit('MUTATION_CHANGE_FILTER', payload);
  },
  GET_TEMPLATE: ({ commit }, params) => {
    commit('MUTATION_GET_TEMPLATE', params);
  },
  UPDATE_TEMPLATE: ({ commit }, params) => {
    commit('MUTATION_UPDATE_TEMPLATE', params);
  },
  DELETE_TEMPLATE: ({ commit }, params) => {
    commit('MUTATION_DELETE_TEMPLATE', params);
  },
  SELECT_TEMPLATE: ({ commit }, params) => {
    commit('MUTATION_SELECT_TEMPLATE', params);
  },
  INIT_INPUT_VALUE: ({ commit }, params) => {
    commit('MUTATION_INIT_INPUT_VALUE', params);
  },
  SET_INPUT_VALUE: ({ commit }, params) => {
    commit('MUTATION_SET_INPUT_VALUE', params);
  }
}

const mutations = {
  MUTATION_CHANGE_FILTER: (state, payload) => {
    state["param"]["filter"] = payload;
  },
  MUTATION_GET_TEMPLATE: (state, payload) => {
    if (payload && payload.data) {
      const { list } = payload.data;
      const { offset, limit } = payload.config.params;
      const totalCount = list && list.length > 0 ? list[0].rnum + offset : 0;
      const totalPages = Math.ceil(totalCount / limit);
      state['data'] = list ? list[0] : null;
      state['needReload'] = false;
      state['totalCount'] = totalCount;
      state['totalPages'] = totalPages;
      // selectedNoArray 초기화 제거 - 선택 상태 보존
    }
  },
  MUTATION_UPDATE_TEMPLATE: (state, payload) => {
    state['needReload'] = true;
  },
  MUTATION_DELETE_TEMPLATE: (state, payload) => {
    state['needReload'] = true;
  },
  MUTATION_SELECT_TEMPLATE: (state, payload) => {
    state['selectedNoArray'] = payload;
  },
  MUTATION_INIT_INPUT_VALUE: (state, payload) => {
    state['inputValues'] = {};
  },
  MUTATION_SET_INPUT_VALUE: (state, payload) => {
    Object.keys(payload).map(key => {
      state["inputValues"][key] = payload[key];
    })
  }
}

const getters = {
  STATE: (state) => {
    return state
  },
  GET_INPUT_VALUES: (state) => {
    return state.inputValues;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}